(function () {
	var COOKIE_NAME = 'shopify_recently_viewed';
	var COOKIE_PATH = '/';
	var COOKIE_DOMAIN = window.location.hostname;
	var COOKIE_EXPIRES_DAYS = 90;

	function setCookie(name, value, days) {
		var expires = '';
		if (days != null) {
			var d = new Date();
			d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + d.toUTCString();
		}
		document.cookie = name + '=' + encodeURIComponent(value || '') + expires +
			'; path=' + COOKIE_PATH + '; domain=' + COOKIE_DOMAIN;
	}

	function getCookie(name) {
		var prefix = name + '=';
		var parts = document.cookie ? document.cookie.split(';') : [];
		for (var i = 0; i < parts.length; i++) {
			var c = parts[i].replace(/^\s+/, '');
			if (c.indexOf(prefix) === 0) {
				return decodeURIComponent(c.substring(prefix.length));
			}
		}
		return null;
	}

	function deleteCookie(name) {
		setCookie(name, '', -1);
	}

	var storage = {
		read: function () {
			var v = getCookie(COOKIE_NAME);
			return v ? v.split(' ') : [];
		},
		write: function (list) {
			setCookie(COOKIE_NAME, list.join(' '), COOKIE_EXPIRES_DAYS);
		},
		destroy: function () {
			deleteCookie(COOKIE_NAME);
		},
		remove: function (handle) {
			var list = this.read();
			var i = list.indexOf(handle);
			if (i !== -1) {
				list.splice(i, 1);
				this.write(list);
			}
		}
	};

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function escapeAttr(str) {
		return escapeHtml(str);
	}

	function resizeImage(src, size) {
		if (src == null) return src;
		if (size === 'master') return src.replace(/http(s)?:/, '');
		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
		if (!match) return null;
		var parts = src.split(match[0]);
		return (parts[0] + '_' + size + match[0]).replace(/http(s)?:/, '');
	}

	function renderTemplate(template, data) {
		return template.replace(/\$\{(\w+)\}/g, function (m, key) {
			return data[key] != null ? data[key] : '';
		});
	}

	var config = {
		howManyToShow: 3,
		howManyToStoreInMemory: 10,
		wrapperId: 'recently-viewed-products',
		templateId: 'recently-viewed-product-template',
		onComplete: null
	};

	var queue = [];
	var wrapper = null;
	var templateHtml = null;
	var shown = 0;

	function finish() {
		if (wrapper) wrapper.style.display = '';
		if (typeof config.onComplete === 'function') {
			try { config.onComplete(); } catch (e) {}
		}
	}

	function fetchNext() {
		if (!queue.length || shown >= config.howManyToShow) {
			finish();
			return;
		}
		var handle = queue[0];
		fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
			.then(function (res) {
				if (!res.ok) throw new Error('not ok');
				return res.json();
			})
			.then(function (product) {
				var html = renderTemplate(templateHtml, {
					handle: escapeAttr(product.handle),
					url: escapeAttr(product.url),
					title: escapeHtml(product.title),
					image: escapeAttr(resizeImage(product.featured_image, 'medium') || '')
				});
				wrapper.insertAdjacentHTML('beforeend', html);
				queue.shift();
				shown++;
				fetchNext();
			})
			.catch(function () {
				storage.remove(queue[0]);
				queue.shift();
				fetchNext();
			});
	}

	window.Shopify = window.Shopify || {};
	window.Shopify.Products = {
		resizeImage: resizeImage,

		showRecentlyViewed: function (options) {
			var opts = options || {};
			Object.keys(opts).forEach(function (k) { config[k] = opts[k]; });

			queue = storage.read();
			var templateEl = document.getElementById(config.templateId);
			wrapper = document.getElementById(config.wrapperId);
			if (!templateEl || !wrapper) return;
			templateHtml = templateEl.innerHTML;

			config.howManyToShow = Math.min(queue.length, config.howManyToShow);
			shown = 0;
			if (config.howManyToShow) {
				fetchNext();
			}
		},

		getConfig: function () {
			return config;
		},

		clearList: function () {
			storage.destroy();
		},

		recordRecentlyViewed: function (options) {
			var opts = options || {};
			Object.keys(opts).forEach(function (k) { config[k] = opts[k]; });

			if (window.location.pathname.indexOf('/products/') === -1) return;
			var match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
			if (!match) return;
			var handle = match[1];

			var list = storage.read();
			var idx = list.indexOf(handle);
			if (idx === -1) {
				list.unshift(handle);
				list = list.slice(0, config.howManyToStoreInMemory);
			} else {
				list.splice(idx, 1);
				list.unshift(handle);
			}
			storage.write(list);
		}
	};
})();
